// This file's entirely about extending native functionality.
/* eslint-disable no-extend-native */

import mathSign from 'core-js/features/math/sign';
import mathTrunc from 'core-js/features/math/trunc';

Math.sign = Math.sign || mathSign;
Math.trunc = Math.trunc || mathTrunc;
